<template>
    <div id="account-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="box clearfix">
                        <div class="title">
                            <h3>{{ t('account-rewards-title') }}</h3>
                            <div class="badge badge-success">
                                {{ data.balance }} {{ t('account-rewards-points') }}
                            </div>
                        </div>
                        <loader :inline="true" v-if="!loaded"/>
                        <div class="points" v-if="data.rewards.length > 0 && loaded">
                            <div class="rewards">
                                <div
                                    class="reward"
                                    v-for="reward in data.rewards"
                                    :key="reward.id"
                                    :class="{ checked: reward.price <= data.balance }"
                                >
                                    <div class="marker"></div>
                                    <div class="points">
                                        <em class="price">{{ reward.price }}</em>
                                        <br/>
                                        {{ t('account-rewards-points_label') }}
                                    </div>
                                    <div class="text">
                                        <div class="name">
                                            {{ reward.description }}
                                            <template
                                                v-if="reward.self_usable === '1' && reward.price <= data.balance"
                                            >
                                                <button
                                                    class="btn btn-primary btn-sm"
                                                    @click="useReward(reward)"
                                                >
                                                    {{ t('account-rewards-use_now') }}
                                                </button>
                                            </template>
                                        </div>
                                        <div
                                            class="condition"
                                            v-if="reward.price <= data.balance && reward.self_usable !== '1'"
                                        >
                                            {{ t('account-rewards-support_contact') }}
                                        </div>
                                        <div
                                            class="condition"
                                            v-if="reward.price - data.balance > 1"
                                        >
                                            {{ t('account-rewards-missing') }}
                                            {{ reward.price - data.balance }} {{ t('account-rewards-points') }}
                                        </div>
                                        <div
                                            class="condition"
                                            v-if="reward.price - data.balance === 1"
                                        >
                                            {{ t('account-rewards-missing_one') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped="true" lang="less">
.title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}

.badge {
    background: var(--primary);
}

.rewards {
    margin-top: 15px;

    .reward {
        position: relative;
        padding-left: 30px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;

        .points {
            text-align: center;
            font-weight: 700;
            font-size: 11px;
            margin-top: 7px;
            margin-right: 10px;

            em {
                font-size: 16px;
                line-height: 19px;
                font-style: normal;
                font-weight: 400;
            }
        }

        .text {
            width: 100%;
            display: flex;
            align-items: center;

            .name {
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0.15px;
                color: rgba(0, 0, 0, 0.87);
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .condition {
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 0.25px;
                color: #9e9e9e;
                text-align: right;
            }
        }

        &:before {
            content: "";
            width: 2px;
            height: 100%;
            position: absolute;
            bottom: 50%;
            left: 10px;
            background: #cad4dc;
            z-index: 1;
        }

        &:first-child:before {
            display: none;
        }

        .marker {
            display: block;
            position: absolute;
            width: 17px;
            height: 17px;
            border-radius: 50%;
            background: #fff;
            border: 2px solid #cad4dc;
            top: 50%;
            left: 2px;
            margin-top: -8px;
            z-index: 2;
        }

        &.checked {
            &:before,
            &:after {
                background: var(--primary);
            }

            .marker {
                border-color: var(--primary);

                &:after {
                    content: "";
                    display: block;
                    position: absolute;
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background: var(--primary);
                    top: 50%;
                    left: 50%;
                    margin: -4px;
                }
            }
        }
    }
}

</style>
<script>
import keviApi from "../keviApi";
import {init, getData, useReward} from "../keviClientSDK";

export default {
    props: {
        user: Object,
    },
    data() {
        return {
            accountToken: null,
            loaded: false,
            usingReward: null,
            data: {
                balance: 0,
                rewards: [],
                coupons: []
            }
        }
    },
    mounted() {
        document.getElementsByTagName("title")[0].innerText =
            "Kevi | " + this.t('account-rewards-page_title');
        this.getToken();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        async getToken() {
            this.loaded = false;
            const options = keviApi.getOptions('/me/kevi-token');
            const response = await this.$http(options);
            this.accountToken = response.data.token;
            if (this.accountToken) {
                init(this.accountToken);
                const response = await getData();
                this.data = response.data;
            }
            this.loaded = true;
        },
        async useReward(reward) {
            if (confirm(this.t('account-rewards-confirm_redeem'))) {
                await useReward(reward.id);
                this.getToken();
                alert(this.t('account-rewards-redeem_success') + " \n"
                    + reward.client_success_message
                );
            }
        },
    },
};
</script>
